<app-breadcrumb
  [items]="(breadcrumbs$ | async) ?? []"
  [title]="(title$ | async) ?? ''">
</app-breadcrumb>

<div class="section mb-40 relative" *ngIf="!(navigationMenu.isHelixLiteAvailable$ | async)">
  <div class="section-content">
    <app-page-navigation [isOnLoyaltyPage]="false"></app-page-navigation>
  </div>
</div>

<ng-container *ngIf="dataLoaded$ | async; else skeleton">
  <div class="section">
    <div class="section-content">
      <ng-container *ngIf="sliders$ | async as sliders">
        <section class="hidden-xs mb-64" *ngIf="sliders.length">
          <app-promotions-slider [sliders]="sliders"></app-promotions-slider>
        </section>
      </ng-container>

      <ng-container *ngIf="promotionsList$ | async as promotionsList">
        <ng-container *ngIf="promotionsList?.length">
          <div class="typography typography-paragraph typography-h1">
            Все акции
          </div>

          <app-all-promotions
            [promotionsList]="promotionsList"
          ></app-all-promotions>
        </ng-container>

        <ng-container *ngIf="!promotionsList?.length">
          <div class="empty">
            На данный момент в&nbsp;выбранном вами регионе нет&nbsp;подходящих
            акций
          </div>
        </ng-container>

      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #skeleton>
  <app-skeleton></app-skeleton>
</ng-template>
